<template>
  <div class="firmwareNew">
    <div class="section">
      <div class="search">
        <!-- <div class="list-header">
          <div class="title">{{$t('firmware.Firmware_Lists')}}</div>
        </div> -->
        <!-- <div class="search"> -->
        <button type="button" class="button-upload" @click="openCreateFirmwareDialog()">
          {{ $t('firmware.Upload_firmware') }}
          <i class="iconfont icon-biaogegongneng_shangchuan"></i>
        </button>
      </div>
      <el-table class="tablemain tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading"
        height="100%" stripe border :data="dataCode"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" :empty-text="$t('account.nodata')">
        <el-table-column width="80px" type="index" :label="$t('recharge.serial_number')" header-align="center"
          align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firmwareName" :label="this.$t('firmware.Firmware_Name')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firmwareVersion" :label="this.$t('firmware.Firmware_Version')" min-width="100px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fileSize" :label="this.$t('firmware.Size')" :show-overflow-tooltip="true"  min-width="120px"></el-table-column>
        <el-table-column :label="this.$t('firmware.Firmware_desrc')" min-width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.note || '--'">{{ scope.row.note || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="this.$t('firmware.Upload_Time')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="this.$t('firmware.Operation')" fixed="right" width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button type="text" class="operation" :title="$t('firmware.editFirmware')" @click="editFirmwareDialog(scope.row)">
              <i class="iconfont icon-bianji"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('firmware.downloadFirmware')"
              @click="downloadFirmware(scope.row)">
              <i class="iconfont icon-a-mingchengxiazai2"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('firmware.deleteFirmware')"
              @click="deleteFirmware(scope.row)">
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
                <div style="line-height: 32px">{{$t('account.nodata')}}</div></div> -->
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <el-pagination class="pagination" background @size-change="getData(true)" @current-change="() => getData()"
          :current-page.sync="pagination.currentPage" :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize" layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>

    <!-- 删除固件对话框 -->
    <!-- v-if="dialogVisible" -->
    <firmware-dialog :title="$t('firmware.del_firmware')" :visible.sync="dialogVisible"
      :class="{ 'showDialog': dialogVisible, 'hideDialog': !dialogVisible }" width="35vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('firmware.delete_firmware') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('upgradeManagement.delete_desc') }}</span>
        </div>
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" @click="configdelete()" style="margin-right:10px;">{{
            $t('firmware.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="dialogVisible = false">{{ $t('firmware.cancel') }}</button>
        </div>
      </div>
    </firmware-dialog>
    <!-- 下载固件对话框 -->
    <!-- v-if="dialogVisible" -->
    <firmware-dialog :title="$t('upgradeManagement.download_firmware')" :visible.sync="downloadFirmwareVisible"
      :class="{ 'showDialog': downloadFirmwareVisible, 'hideDialog': !downloadFirmwareVisible }" width="35vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('upgradeManagement.download_firmware_prompt') }}</span>
        </div>
        <!-- <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('upgradeManagement.delete_desc') }}</span>
        </div> -->
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" @click="configdownload()" style="margin-right:10px;">{{
            $t('firmware.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="downloadFirmwareVisible = false">{{ $t('firmware.cancel') }}</button>
        </div>
      </div>
    </firmware-dialog>

    <!-- 增加固件对话框 -->
    <firmware-dialog :visible.sync="firmwareVisible"
      :class="{'showDialog': firmwareVisible, 'hideDialog': !firmwareVisible}"
      width="420px"
      noContentClose
      :title="$t('upgradeManagement.upload_firmware')" >
      <div slot="content">
        <el-form  
          :model="firmwareForm"
          :rules="firmwareRules" 
          ref="createFirmwareForm" 
          label-width="100px" 
          class="eb-form"
          label-position="top"
        >
          <el-form-item prop="name" class="el-form-group-item">
            <!-- 固件名称  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff;">{{$t('upgradeManagement.firmware_name')}}</span>
            </span>
            <!-- content -->
            <span 
              class="eb-inputwrapper" 
              style="margin-right:10px;width:100%"
            >
              <el-input 
                class="eb-input"
                :placeholder="$t('upgradeManagement.please_input')"
                v-model="firmwareForm.name" 
                clearable
                :maxlength="32"
              ></el-input>
            </span>
          </el-form-item>
          <el-form-item prop="versionNote" class="el-form-group-item">
            <!-- 版本号  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff;">{{$t('upgradeManagement.Firmware_Version')}}</span>
            </span>
            <!-- content -->
            <span 
              class="eb-inputwrapper" 
              style="margin-right:10px;width:100%"
            >
              <el-input 
                class="eb-input"
                :placeholder="$t('upgradeManagement.please_input')"
                v-model="firmwareForm.versionNote" 
                clearable
                :maxlength="16"
              ></el-input>
            </span>
          </el-form-item>
          <el-form-item prop="note" class="el-form-group-item">
            <!-- 备注说明  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff">{{$t('upgradeManagement.Remarks')}}</span>
            </span>
            <!-- content -->
            <el-input
              type="textarea"
              :placeholder="$t('firmware.enter_content')"
              v-model="firmwareForm.note"
              :maxlength="64"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item  prop="file" class="el-form-group-item">
            <!-- 上传固件  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff;">{{$t('upgradeManagement.Upload')}}</span>
            </span>
            <!-- content -->
            <el-upload
              accept=".bin,.hex"
              class="upload-demo"
              :action="actionUrl"
              ref="upload"
              :on-remove="deleteFile"
              :file-list="fileobj"
              :on-change="handleChange"
              :http-request="httpRequest"
              :auto-upload="false">
              <el-button class="button button-solid" style="margin-right:5px">
                <span style="padding-right:0;" class="iconfont icon-a-mingchengbi3"></span>
                <span size="small" type="primary">{{$t('upgradeManagement.Upload')}}</span>
              </el-button>
              
              <span style="color:#fff;" slot="tip" class="el-upload__tip">{{$t('upgradeManagement.upgrade_file_format')}}</span>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <!-- 取消  -->
        <el-button
          class="btn btn-light"
          style="margin-left:10px;"
          @click="firmwareVisible=false;"
        ><span>{{$t('upgradeManagement.cancel')}}</span></el-button>
        <!-- 确认  -->
        <el-button
          class="btn btn-dark"
          style="margin-left:10px;"
          @click="createFirmware()"
        >
          <span>{{$t('upgradeManagement.confirm')}}</span>
        </el-button>
      </div>
    </firmware-dialog>
    <!-- 编辑固件对话框 -->
    <firmware-dialog :visible.sync="editFirmwareVisible"
      :class="{'showDialog': editFirmwareVisible, 'hideDialog': !editFirmwareVisible}"
      width="420px"
      noContentClose
      :title="$t('upgradeManagement.edit_firmware')" >
      <div slot="content">
        <el-form  
          :model="editFirmwareForm"
          :rules="editFirmwareRules" 
          ref="editFirmwareForm" 
          label-width="100px" 
          class="eb-form"
          label-position="top"
        >
          <el-form-item prop="name" class="el-form-group-item">
            <!-- 固件名称  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff;">{{$t('upgradeManagement.firmware_name')}}</span>
            </span>
            <!-- content -->
            <span 
              class="eb-inputwrapper" 
              style="margin-right:10px;width:100%"
            >
              <el-input 
                class="eb-input"
                :placeholder="$t('upgradeManagement.please_input')"
                v-model="editFirmwareForm.name" 
                clearable
                :maxlength="32"
              ></el-input>
            </span>
          </el-form-item>
          <el-form-item prop="versionNote" class="el-form-group-item">
            <!-- 版本号  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff;">{{$t('upgradeManagement.Firmware_Version')}}</span>
            </span>
            <!-- content -->
            <span 
              class="eb-inputwrapper" 
              style="margin-right:10px;width:100%"
            >
              <el-input 
                class="eb-input"
                :placeholder="$t('upgradeManagement.please_input')"
                v-model="editFirmwareForm.versionNote" 
                clearable
                :maxlength="16"
              ></el-input>
            </span>
          </el-form-item>
          <el-form-item prop="note" class="el-form-group-item">
            <!-- 备注说明  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff">{{$t('upgradeManagement.Remarks')}}</span>
            </span>
            <!-- content -->
            <el-input
              type="textarea"
              :placeholder="$t('firmware.enter_content')"
              v-model="editFirmwareForm.note"
              :maxlength="64"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <!-- 取消  -->
        <el-button
          class="btn btn-light"
          style="margin-left:10px;"
          @click="editFirmwareVisible=false;"
        ><span>{{$t('upgradeManagement.cancel')}}</span></el-button>
        <!-- 确认  -->
        <el-button
          class="btn btn-dark"
          style="margin-left:10px;"
          @click="editFirmware()"
        >
          <span>{{$t('upgradeManagement.confirm')}}</span>
        </el-button>
      </div>
    </firmware-dialog>
  </div>
</template>
<script>
import firmwareDialog from "@/components/dialognew";
export default {
  components: {
    firmwareDialog
  },
  data () {
    return {
      // 上传文件列表
      fileobj:[],
      // 文件上传地址
      actionUrl:"/upg/api/auth/web/device/firmware",
      // 上传固件弹窗开关
      firmwareVisible:false,
      // 编辑固件弹窗开关
      editFirmwareVisible:false,
      // 删除固件弹窗开关
      deleteFirmwareVisible:false,
      // 下载固件弹窗开关
      downloadFirmwareVisible:false,
      // 上传固件数据
      firmwareForm:{
        note:"",
        deleteFlag:0,
        versionNote:"",
        file:"",
        name:"",
        mode:1,
      },
      //编辑固件数据
      editFirmwareForm:{
        note:"",
        deleteFlag:0,
        versionNote:"",
        file:"",
        name:"",
        mode:1,
      },
      firmwareRules:{
        name:[
          {required: true, message: this.$t("upgradeManagement.firmwareName_empty"), trigger: ['blur','change']}
        ],
        versionNote:[
          {required: true, message: this.$t("upgradeManagement.firmwareVersion_empty"), trigger: ['blur','change']}
        ],
      },
      editFirmwareRules:{
        name:[
          {required: true, message: this.$t("upgradeManagement.firmwareName_empty"), trigger: ['blur','change']}
        ],
        versionNote:[
          {required: true, message: this.$t("upgradeManagement.firmwareVersion_empty"), trigger: ['blur','change']}
        ],
      },
      emptyText: false,
      isLoading: false,
      file: null, //保存上传文件流的容器
      form: {
        name: ""
      },
      desc: "",
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100
      },
      // 固件列表
      dataCode: [
        // { "firmware": "mcu+4g_3_5_4_2.bin-ota.bin",}
      ],
      params: "",
      // 删除固件
      dialogVisible: false,
      // 增加固件
      dialogAdd: false,
      
    };
  },
  methods: {
    // 固件下载弹窗
    downloadFirmware(info){
      let action="/upg/api/auth/web/device/firmware/download/"+info.id
      this.$request.postDownload(action,{id:info.id}).then(res=>{
        if(res.data){
          this.$message.success(this.$t("upgradeManagement.download_success"))
          const disposition = res.headers["content-disposition"];
            let fileName = disposition.substring(
              disposition.indexOf("filename=") + 9,
              disposition.length
            );
            fileName = decodeURI(escape(fileName));
            const content = res.data;
            let url = window.URL.createObjectURL(new Blob([content]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
        }else{
          this.$message.error(this.$t("upgradeManagement.download_exception"))
        }
      })
    },
    // 编辑固件提交
    editFirmware(){
      this.$refs.editFirmwareForm.validate(valid=>{
        if (!valid) return false

        let action="/upg/api/auth/web/device/firmware/"+this.editFirmwareForm.id
        let params={
          deleteFlag:this.editFirmwareForm.deleteFlag,
          firmwareName:this.editFirmwareForm.name,
          firmwareVersion:this.editFirmwareForm.versionNote,
          note:this.editFirmwareForm.note,
          upgradeMode:this.editFirmwareForm.mode,
          i18n: this.$lang.currentLang,
        }
        this.$request.put(action,params).then((res)=>{
          if (res.code==0) {
            this.$message.success(this.$t("upgradeManagement.eidt_success"))
            this.editFirmwareVisible=false
            this.getData()
          }else{
            this.$message.error(res.message)
          }
        })
      })
    },
    // 编辑固件弹窗
    editFirmwareDialog(info){
      this.editFirmwareVisible=true
      this.editFirmwareForm.name=info.firmwareName
      this.editFirmwareForm.versionNote=info.firmwareVersion
      this.editFirmwareForm.note=info.note
      this.editFirmwareForm.id=info.id
    },
    // 自定义提交上传固件信息
    httpRequest(params){
      this.$refs.createFirmwareForm.validate(valid=>{
        if (!valid) return false
        let param={
          firmwareName:this.firmwareForm.name,
          deleteFlag:this.firmwareForm.deleteFlag,
          versionNote:this.firmwareForm.versionNote,
          note:this.firmwareForm.note,
          upgradeMode:this.firmwareForm.mode,
          code:this.firmwareForm.code,
          i18n: this.$lang.currentLang,
        }
        this.$request.uploadFirmware(params.action,params.file,param).then((res)=>{
          if (res.code==0) {
            this.$message.success(this.$t("upgradeManagement.upgrade_success"))
            this.firmwareVisible=false
            this.getData()
          }else{
            this.firmwareVisible=false
            this.$message.error(res.message)
          }
        })
      })
    },
    // 提交固件信息
    createFirmware(){
      this.$refs.createFirmwareForm.validate(valid=>{
        if (!valid) return false
        if (this.fileobj.length!=1) {
          this.$message.error(this.$t("upgradeManagement.please_upgrade"));
          return false
        }
        
        this.$refs.upload.submit();
      })     
    },
    // 上传固件-弹窗
    openCreateFirmwareDialog(){
      this.firmwareVisible=true
      this.fileobj=[]
      this.$refs['createFirmwareForm'].resetFields();
    },
    // 删除文件钩子
    deleteFile(){
      this.fileobj=[]
    },
    // 上传文件钩子函数
    handleChange(file,fileList){
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.fileobj=[]
        this.$message.error(this.$t("upgradeManagement.upgrade_file_format1"));
        return;
      }else{
        if (fileList.length>1) {
          fileList.splice(0,1)
          this.fileobj=fileList
        }else{
          this.fileobj=fileList
        }
        if (file.size > 1000 * 1024) {
          this.fileobj=[]
          this.$message.error(this.$t("upgradeManagement.upgrade_file_format2"));
          return;
        }
      }
    },
    // 固件列表数据
    getData (reset) {
      if (reset) this.pagination.currentPage = 1;
      this.isLoading = true;
      this.$request
        .getUPG("/upg/api/auth/web/device/firmwares", {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pagesize,
          i18n: this.$lang.currentLang,
        })
        .then(res => {
          if (res.code == 0) {
            this.dataCode = res.data.items;
            this.dataCode.forEach(item=>{
              item.fileSize=(item.fileSize/1024).toFixed(2);
            })
            this.pagination.total = Number(res.data.total)
            
          } else {
            this.emptyText = true;
            this.dataCode = [];
            this.pagination.total = 0;
          }
          this.isLoading = false;
        }).catch((err)=>{
          this.emptyText = true;
          this.dataCode = [];
          this.pagination.total = 0;
          this.isLoading = false;
        });
    },
    //删除固件进入界面按钮
    deleteFirmware (info) {
      this.dialogVisible = true;
      this.params = info;
    },
    //删除固件
    configdelete () {
      let action="/upg/api/auth/web/device/firmware/"+this.params.id
      this.$request.delete(action).then(res => {
        if (res.code == 0) {
          this.$message.success(this.$t("upgradeManagement.delete_success1"))
          setTimeout(() => {
            this.getData();
          }, 500);
          this.dialogVisible = false;
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //增加固件进入界面按钮
    addFirmware () {
      this.firmwareVisible = true;
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      // this.$nextTick(() => {
      //   this.$refs.fileUploader.value = null;
      //   this.desc = null;
      // });
    },
  },
  mounted () {
    this.getData();
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

.firmwareNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;
  /deep/.el-upload-list__item:hover{
    background-color: rgba(34, 45, 53, 1);
  }
  .upload-demo /deep/ .el-icon-close{
      color: #fff;
    }
  /deep/.el-upload-list__item-name{
    color: #fff;
    .el-icon-document{
      color: #fff;
    }
    
  }
  // margin: 24px 24px 50px 24px;
  .btn {
    height: 31px;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .search {
    margin: 0px;
    align-self: flex-end;

    // display: flex;
    // justify-content: space-between;
    .button-upload {
      display: flex;
      //多语言状态下文字间隔优化
      line-height: 16px;
      justify-content: space-between;
      align-items: center;
      width: 114px;
      height: 48px;
      background: @primaryTextColor;
      color: rgb(34, 45, 53);
      font-size: 14px;
      border-radius: 0px;
      border: none;
      cursor: pointer;

      .ico-download {
        width: 16px;
        height: 16px;
        background: url(../../assets/img/general/Icon_Download.png) no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 10px;
      }
    }
  }

  .upload-button {
    margin-left: 80px;
    padding: 6px 16px;
  }

  .section {
    // padding-bottom: 10px;
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: hidden;

    // .list-header {
    //   .title {
    //    font-size:16px;
    //    font-weight: bold;
    //    color: #333;
    //    letter-spacing: 1.5px;
    //     // .sc(24px, #333);
    //   }
    // }
    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  // .contentdelete {
  //   font-size: 18px;
  //   color: rgba(255, 62, 62, 1);
  //   font-weight: bold;
  // }
  // .disabledescr {
  //   color: rgba(255, 255, 255, 1);
  //   font-size: 14px;
  // }
  .deletfotter {
    margin-top: 50px;

    .button-hollow {
      width: 100px;
      height: 40px;
      margin-right: 40px;
    }

    .button-solid {
      width: 100px;
      height: 40px;
    }
  }

  .upload-input {
    display: none;
  }

  // 上传固件弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
.firmware {
  .search {

    .el-select,
    .el-input {
      width: 165px;

      .el-input__inner {
        height: 36px;
        line-height: 36px;
        border-radius: 20px;
      }
    }
  }

  .upload-button {
    width: 100%;
  }
}
</style>